import type { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useAuth } from './auth';
import { routePermission } from './permissions';
import Forbidden from '../screens/Forbidden';

// Layout route between the shell and the screens: renders the 403 page when the route's permission is missing (permissions.ts).
export function PermissionGate() {
  const { pathname } = useLocation();
  const permissions = useAuth((s) => s.user?.permissions);
  const needed = routePermission(pathname);
  if (needed && !permissions?.includes(needed)) return <Forbidden permission={needed} />;
  return <Outlet />;
}

/** True when the signed-in user holds `code`. UI hides, API enforces (skill aerostores-security). */
export function usePermission(code: string): boolean {
  return useAuth((s) => s.user?.permissions.includes(code) ?? false);
}

/**
 * The in-screen half of the gate: renders `children` only with the permission, otherwise `fallback`.
 * Used for the cost controls (`cost.view`) — the field and its label stay (screen parity), the editor becomes the read-only dash.
 */
export function Permitted({ code, fallback = null, children }: { code: string; fallback?: ReactNode; children: ReactNode }) {
  return usePermission(code) ? <>{children}</> : <>{fallback}</>;
}
